/*
 * @Author: tianzhitong laotianwy@163.com
 * @Date: 2023-08-25 10:33:37
 * @LastEditors: yusha
 * @LastEditTime: 2024-03-13 14:28:17
 * @FilePath: /ckb-smc-client-fed/src/common/Layout/Header/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Cookie from 'js-cookie';
import { Header } from 'antd/es/layout/layout';
import { useTranslation } from 'react-i18next';
import { Dropdown, Popover, message } from 'antd';
import { useRequest } from 'ahooks';
import { useState } from 'react';
import axios from 'axios';
import { atom, useAtom, useAtomValue, useSetAtom } from 'jotai';
import { getLang, getLocalByLang, strings } from '@/i18n/i18n';
import { request } from '@/config/request';
import { CustomerRespDTO } from '@/service/customer';
import { goLogin } from '@/utils';
import { serviceConfig } from '@/config/request/swaggerServiceConfig';
import { User } from '@/model/index';
import { Site } from '@/const/enum';
import { useGetExchangeText } from '@/hooks/useYan';
import { CACHE_STATION_NAME } from '@/const/staticURL';
import { useCurrentLang } from '@/hooks/useConfig';
import { TokenSignCookie } from '@/config';
import styles from './index.module.scss';

export const atomtUserDetail = atom<CustomerRespDTO | undefined>(undefined);
export interface CustomerRes extends CustomerRespDTO {
    nationCode?: string;
}

export const LayoutHeader = () => {
    const [info, setInfo] = useState<CustomerRespDTO>();
    const [exchangeRate, setExchangeRate] = useAtom(User.exchangeRate);
    const [t, i18n] = useTranslation();
    // 存储用户信息
    const setUserDetail = useSetAtom(User.atomRequestUserDetail);
    const [stationCode, setStationCode] = useAtom(User.stationCode);
    const langType = useCurrentLang();
    const apiLogout = useRequest(request.customer.logout.logout, {
        manual: true,
        debounceWait: 500
    });

    useRequest(request.customer.getCustomerSimple.getCustomerSimple, {
        onSuccess(res) {
            // 获取用户信息站点。缓存到localstorage里。方便账号退出得知当前站点信息
            const cacheStationCodeName =
                (res.data!.stationCode as Site) || Site.JP;
            setStationCode(cacheStationCodeName);
            window.localStorage.setItem(
                CACHE_STATION_NAME,
                cacheStationCodeName
            );
            setInfo(res.data);
            setUserDetail(res.data!);
            axios
                .get(
                    serviceConfig.baseURL +
                        '/settlement/exchangeRate/cnyToJpyExchangeRateAfterConfigFloat?mainCustomerId=' +
                        res.data?.customerId
                )
                .then((res) => {
                    let value = res?.data?.data?.exchangeRate;
                    if (stationCode === Site.UK) {
                        const num =
                            1 / Number(res?.data?.data?.exchangeRate ?? 0);
                        value = num.toFixed(4);
                    }
                    setExchangeRate(value);
                });
        },
        onError(res: any) {
            axios
                .get(
                    serviceConfig.baseURL +
                        '/settlement/exchangeRate/getOriginExchangeRate?stationCode=' +
                        stationCode
                )
                .then((res) => {
                    if (res?.data?.data?.exchangeRate) {
                        let value = res?.data?.data?.exchangeRate;
                        if (stationCode === Site.UK) {
                            value =
                                1 / Number(res?.data?.data?.exchangeRate ?? 0);
                        }
                        if (stationCode === Site.JP) {
                            setExchangeRate(value + 1);
                            return;
                        }

                        setExchangeRate(value);
                    }
                });
        }
    });

    const exchangeText = useGetExchangeText();
    return (
        <>
            <Header className={styles.header}>
                <div className={styles.actions}>
                    <img
                        onClick={() => {
                            window.location.href = '/';
                        }}
                        className={styles.logo}
                        alt="logo"
                        src={
                            stationCode === Site.JP
                                ? 'https://static-jp.theckb.com/static-asset/client/homelogo_w.png'
                                : 'https://static-s.theckb.com/BusinessMarket/Client/homelogo_w.png'
                        }
                    />
                </div>

                {exchangeRate && (
                    <div className={styles.exchangeCover}>
                        <div className={styles.exchange}>{exchangeText}</div>
                        {/* CNY1={{ getCountryCurrency() }}{{ getFloatingRate(floatingRate) }} */}
                    </div>
                )}

                {info && (
                    <Popover
                        content={
                            <div
                                className={styles.exit}
                                onClick={() => {
                                    apiLogout
                                        .runAsync()
                                        .then(() => {
                                            const lang =
                                                localStorage.getItem(
                                                    '__lang__'
                                                ) ||
                                                localStorage.getItem('lang');
                                            window.localStorage.clear();
                                            document.cookie = `production_route/token=; path=/`;
                                            window.localStorage.removeItem(
                                                'production_route/token'
                                            );

                                            message
                                                .success(
                                                    strings.t('退出成功'),
                                                    2
                                                )
                                                .then(() => {
                                                    const _lang =
                                                        getLocalByLang.get(
                                                            lang
                                                        ) ??
                                                        lang ??
                                                        'ja';
                                                    window.location.href =
                                                        '/smc/promotion/index' +
                                                        `?lang=${_lang}`;
                                                });
                                        })
                                        .catch((err) => message.error(err));
                                }}
                            >
                                {strings.t('登出')}
                            </div>
                        }
                    >
                        <div className={styles.userWrap}>
                            <img
                                className={styles.avatar}
                                src="//static-s.theckb.com/BusinessMarket/smc/tx-ydl.png"
                                alt=""
                            />

                            <span className={styles.userName}>
                                {info.loginName}
                            </span>
                            <i
                                className={
                                    'iconfont icon-zhankai ' + styles.icon
                                }
                            />
                        </div>
                    </Popover>
                )}

                {!info && (
                    <div className={styles.userWrap}>
                        <img
                            className={styles.avatar}
                            src="https://static-s.theckb.com/BusinessMarket/Client/ckbuser.png?t=2024"
                            alt=""
                        />
                        <a className={styles.loginreg} onClick={goLogin}>
                            {strings.t('登录')}
                        </a>
                        /
                        <a
                            className={styles.loginreg}
                            href={
                                '/signup?redirect=' +
                                encodeURIComponent(window.location.href)
                            }
                        >
                            {strings.t('新規登録')}
                        </a>
                    </div>
                )}
            </Header>
        </>
    );
};
